/* Preserve native carousel/menu behavior; pause promotions while a shopper reads or uses them. */
(() => {
  const init = () => document.querySelectorAll('.topbar announcement-bar').forEach((slider) => {
    if (slider.dataset.jjBound) return;
    slider.dataset.jjBound = 'true';
    const bar = slider.closest('.announcement-bar');
    const control = bar.querySelector('.jj-announcement-control');
    if (!control) return;
    const pause = () => {
      control.setAttribute('paused', '');
      slider.slider?.pausePlayer();
    };
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const respectMotion = () => { if (motion.matches) { slider.removeAttribute('autoplay'); pause(); } };
    respectMotion();
    motion.addEventListener('change', respectMotion);
    bar.addEventListener('focusin', (event) => { if (event.target !== control) pause(); });
    bar.querySelectorAll('.fader').forEach((button) => button.addEventListener('click', pause));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
